import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import dayjs from 'dayjs';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type { Period } from 'lumen/models';
import {
  ABSTRACT_ACTIONS,
  type AbstractActionValue,
} from 'lumen/utils/constants/restriction-actions';

export default class PriceAction extends Model {
  [Type] = 'price-action' as const;

  @belongsTo('period', { async: false, inverse: 'priceAction' })
  declare period: Period;

  @attr('string') declare action: AbstractActionValue;
  @attr('number') declare actionedUserId: number;
  @attr('string') declare autopilotScheduleTimestamp: string | null;
  @attr('string') declare bulkPushId: string | null;
  // TODO: Should we link price-action to Carate?
  @attr('string') declare carateId: string;
  @attr('dayjs') declare createdAt: DayjsTransformReturn;
  @attr('string') declare currency: string;
  @attr('json') declare factors: object;
  @attr('string') declare fromDate: string;
  @attr('string') declare pmsRoomType: string;
  @attr('string') declare pmsStateText: string;
  @attr('string') declare rateCodeId: string;
  @attr('string') declare recommendationId: string;
  @attr('number') declare recommendedRate: number;
  @attr('string') declare source: string;
  @attr('number') declare userOverrideRate: number | null;

  // CLOSING THE LOOP TODO: Do these getters make sense in the model? These seem very specific to Channel Pricing
  /**
   * In Closing The Loop (Channel Pricing) we don't consider price pushes that happened longer than 3 days ago for the icon logic
   * If a price action was created this long ago, we assume that the the latest rates will have been shopped (by either a scheduled liveshop or a backup one)
   *
   */
  get isIrrelevantForClosingTheLoop(): boolean {
    return !this.isRecentPriceAction && this.action === ABSTRACT_ACTIONS.PUSHED;
  }

  /**
   * Returns a boolean whether the price action happened within the last 3 days.
   */
  get isRecentPriceAction(): boolean {
    if (!this.createdAt) {
      return false;
    }

    return dayjs().diff(this.createdAt, 'hours') < 72;
  }
}
